<script setup lang="ts">
import type { ReportTemplate } from "@/types/report-templates.types";
import TemplateSectionFlagItem from "./TemplateSectionFlagItem.vue";
import DrawerContentSection from "../DrawerContentSection.vue";

defineProps<{
  template: ReportTemplate;
}>();
</script>

<template>
  <div class="d-flex flex-column gap-5">
    <DrawerContentSection
      :title="$t('dashboard:templates.drawer.sections.title')"
      :description="$t('dashboard:templates.drawer.sections.description')"
    >
      <div class="d-flex flex-column gap-3">
        <TemplateSectionFlagItem
          :title="$t('dashboard:templates.drawer.sections.views.title')"
          :description="
            $t('dashboard:templates.drawer.sections.views.description')
          "
          :value="template.sectionsList.includes('views')"
        />
        <TemplateSectionFlagItem
          :title="$t('dashboard:templates.drawer.sections.findings.title')"
          :description="
            $t('dashboard:templates.drawer.sections.findings.description')
          "
          :value="template.sectionsList.includes('findings')"
        />
        <TemplateSectionFlagItem
          :title="$t('dashboard:templates.drawer.sections.appendices.title')"
          :description="
            $t('dashboard:templates.drawer.sections.appendices.description')
          "
          :value="template.sectionsList.includes('appendices')"
        />
        <TemplateSectionFlagItem
          :title="$t('dashboard:templates.drawer.sections.conclusion.title')"
          :description="
            $t('dashboard:templates.drawer.sections.conclusion.description')
          "
          :value="template.sectionsList.includes('conclusion')"
        />
        <TemplateSectionFlagItem
          :title="$t('dashboard:templates.drawer.sections.preconisation.title')"
          :description="
            $t('dashboard:templates.drawer.sections.preconisation.description')
          "
          :value="template.sectionsList.includes('preconisation')"
        />
      </div>
    </DrawerContentSection>
  </div>
</template>

<style lang="scss" scoped></style>
